export interface FunnelJourneyClientComponent {
  HasSeenSeatingPage: boolean;

  FunnelJourney: string;

  UsingFixedJourney: boolean;

  OpenChangeSearch: boolean;

  HasServerBasket: boolean;

  DrawerTitle: boolean;

  BrowserDataSubmittedForTransactionId: string;

  Component: string;

  PaymentType: null;

  Origin: string;

  Destination: string;

  Outbound: string;

  Return: string | undefined | null;

  FlexiFares: boolean;

  Adults: number;

  Children: number;

  Infants: number;

  CurrencyPriority: number;

  JourneyPairId: number;

  CarSearchQuery: string;

  languageCode?: string;
}

export interface FunnelJourneyServerComponent {
  isReturnJourney?: boolean;

  CurrencyCode: string;

  Pairs: Pair[];

  FlightsOffers?: { [key: string]: Offer[] } | null;

  FareTypeFlights: FareTypeFlights[];
}

export enum FareClassNames {
  STANDARD = 'Standard',
  STANDARD_PLUS = 'StandardPlus',
  ESSENTIALS = 'Essentials'
}

export enum NewFareClassNames {
  LIGHT = 'Light',
  SMART_PLUS = 'Smart+',
  EXTRA = 'Extra'
}

export interface Pair {
  Id: number;
  IsPrimary: boolean;
  Outbound: string | null;
  Return: string | null;
  Destination: string;
  Origin: string;
  BaseCurrency: string;
}

export interface Offer {
  Fare: OfferFare;
  Products: Product[];
  Passengers: PassengerId[];
  FlightId?: string;
}

export interface OfferFare {
  DisplayName: string;
  FareClass: string;
  BundleCode?: string;
  Price: Price;
  Benefits: Benefit[];
  IncludedProducts: IncludedProduct[];
}

export interface FareTypeFlights {
  FareClass: string;
  FareType: string;
  FlightId: string;
}

export interface Benefit {
  Key: string;
  Quantity: number;
}

export interface IncludedProduct {
  ChargeCode: string;
  DisplayName: string;
  Benefits: Benefit[];
  Price?: Price;
}

export interface Price {
  OfferAmount: number;
  DiscountAmount: number;
}

export interface PassengerId {
  InternalId: string;
}

export interface Product {
  ChargeCode: string;
  DisplayName: string;
  Description: string;
  Price: Price;
  QuantityAvailable: number;
  Benefits: Benefit[];
}

export type FlightSegment = 'Outbound' | 'Inbound';
